// changing h2 tag to h1 
document.addEventListener('DOMContentLoaded', function() {
  // Function to replace h2 with h1
  function replaceH2WithH1(containerId, h2Class) {
    // Get the specific container element by ID
    var container = document.getElementById(containerId);
    
    if (container) {
      // Get the h2 element with the specified class inside the container
      var h2Element = container.querySelector('h2.' + h2Class);
      
      if (h2Element) {
        // Create a new h1 element
        var h1Element = document.createElement('h1');
        // Copy the inner HTML from the h2 element to the h1 element
        h1Element.innerHTML = h2Element.innerHTML;
        // Copy the attributes from the h2 element to the h1 element
        for (var i = 0; i < h2Element.attributes.length; i++) {
          h1Element.setAttribute(h2Element.attributes[i].name, h2Element.attributes[i].value);
        }
        // Replace the h2 element with the new h1 element
        h2Element.parentNode.replaceChild(h1Element, h2Element);
      }
    }
  }
  replaceH2WithH1('Hero-template--17042122211513__hero_iAgxag', 'hero__title');
  replaceH2WithH1('shopify-section-template--17084398796985__image_with_text_Rw7gFw', 'image-with-text__inner-heading');
   replaceH2WithH1('shopify-section-template--17061329797305__image_with_text_Br8HHt', 'image-with-text__inner-heading');
  replaceH2WithH1('shopify-section-template--17084398764217__image_with_text_63YRDM', 'image-with-text__inner-heading');
  replaceH2WithH1('shopify-section-template--17061612552377__image_with_text_BEbkaA', 'image-with-text__inner-heading');
    replaceH2WithH1('shopify-section-template--17061479448761__image_with_text_xM8EeG', 'image-with-text__inner-heading');
   replaceH2WithH1('shopify-section-template--17042122506425__form', 'contact-form__title');
  replaceH2WithH1('shopify-section-template--17090047246521__hero_GkCRiQ', 'hero__title--simple');
   replaceH2WithH1('shopify-section-template--17156418568377__hero_fmRhy3', 'hero__title--simple');
     replaceH2WithH1('shopify-section-template--17181061447865__hero_dUr3zW', 'hero__title--simple');
   replaceH2WithH1('shopify-section-template--17042122113209__featured_blog_WCXDqW', 'blog__title');


});


// change h3 to h2 tag
document.addEventListener('DOMContentLoaded', function() {
  // Function to replace elements
  function replaceH3WithH2(selector) {
    // Get all elements matching the selector
    var elements = document.querySelectorAll(selector);

    // Loop through all elements
    elements.forEach(function(element) {
      // Create a new h2 element
      var h2Element = document.createElement('h2');
      // Copy the inner HTML from the original element to the h2 element
      h2Element.innerHTML = element.innerHTML;
      // Copy the attributes from the original element to the h2 element
      for (var i = 0; i < element.attributes.length; i++) {
        h2Element.setAttribute(element.attributes[i].name, element.attributes[i].value);
      }
      // Replace the original element with the new h2 element
      element.parentNode.replaceChild(h2Element, element);
    });
  }

  // Check if the current URL is the neck page
  var pathname = window.location.pathname;
  if (pathname === '/pages/neck' || pathname === '/pages/lower-back' || pathname === '/pages/knee' || pathname === '/pages/ankle-and-foot' || pathname === '/pages/shoulder') {
    // Replace h3 elements with the class 'step__heading'
    replaceH3WithH2('h3.step__heading');

  }
  if (pathname === '/pages/about-us' ) {
    // Replace h3 elements with the class 'step__heading'
    replaceH3WithH2('h3.multirow-card__heading');

  }
});

// change h2 to h3 tag
document.addEventListener('DOMContentLoaded', function() {
  // Function to replace elements
  function replaceH2WithH3(selector) {
    // Get all elements matching the selector
    var elements = document.querySelectorAll(selector);

    // Loop through all elements
    elements.forEach(function(element) {
      // Create a new h3 element
      var h3Element = document.createElement('h3');
      // Copy the inner HTML from the original element to the h3 element
      h3Element.innerHTML = element.innerHTML;
      // Copy the attributes from the original element to the h3 element
      for (var i = 0; i < element.attributes.length; i++) {
        h3Element.setAttribute(element.attributes[i].name, element.attributes[i].value);
      }
      // Replace the original element with the new h3 element
      element.parentNode.replaceChild(h3Element, element);
    });
  }

  // Check if the current URL is the neck page
  if (window.location.pathname === '/pages/neck' || window.location.pathname === '/pages/lower-back' || window.location.pathname === '/pages/knee' || window.location.pathname === '/pages/ankle-and-foot'
     || window.location.pathname === '/pages/shoulder' || window.location.pathname === '/pages/about-us') {
    // Replace h3 elements with the class 'step__heading'
    replaceH2WithH3('h2.slideshow__title-content');
    // Replace h3 elements with other specific classes if needed
    // replaceH3WithH2('h3.some_other_class');
  }
});




// changing all the given class to p tag for homepage
document.addEventListener('DOMContentLoaded', function() {
  // Function to replace elements
  function replaceElements(selector) {
    // Get all elements matching the selector
    var elements = document.querySelectorAll(selector);

    // Loop through all elements
    elements.forEach(function(element) {
      // Create a new p element
      var pElement = document.createElement('p');
      // Copy the inner HTML from the original element to the p element
      pElement.innerHTML = element.innerHTML;
      // Copy the attributes from the original element to the p element
      for (var i = 0; i < element.attributes.length; i++) {
        pElement.setAttribute(element.attributes[i].name, element.attributes[i].value);
      }
      // Replace the original element with the new p element
      element.parentNode.replaceChild(pElement, element);
    });
  }

  // Check if the current URL is the homepage
  if (window.location.pathname === '/') {
    // Replace h3 elements with the class 'step__heading'
    replaceElements('h3.step__heading');
    // Replace elements with the class 'steps__title'
    replaceElements('h2.steps__title');
    // Replace elements with the class 'banner-grid__title-content'
    replaceElements('h3.banner-grid__title-content');
    replaceElements('.article-card__title:last-child');
    replaceElements('h3.collapsible-content__question');
    replaceElements('h2.footer-block__heading');
    replaceElements('h3.newsletter__title');
    replaceElements('h2.slideshow__title-content');
    replaceElements('h1.product__title');
    replaceElements('h2.drawer__heading');
    replaceElements('h1.product__title h3');
    replaceElements('h1.header__heading');
    replaceElements('h2.header__heading');
  }
});



document.addEventListener('DOMContentLoaded', function() {
  // Function to replace elements
  function replaceElements(selector) {
    // Get all elements matching the selector
    var elements = document.querySelectorAll(selector);

    // Loop through all elements
    elements.forEach(function(element) {
      // Create a new p element
      var pElement = document.createElement('p');
      // Copy the inner HTML from the original element to the p element
      pElement.innerHTML = element.innerHTML;
      // Copy the attributes from the original element to the p element
      for (var i = 0; i < element.attributes.length; i++) {
        pElement.setAttribute(element.attributes[i].name, element.attributes[i].value);
      }
      // Replace the original element with the new p element
      element.parentNode.replaceChild(pElement, element);
    });
  }
  replaceElements('h2.article-card__title');
  replaceElements('h3.collapsible-content__question');
  replaceElements('h2.footer-block__heading');
  replaceElements('h3.newsletter__title');
  replaceElements('h3.multicolumn-card__heading');
  replaceElements('h2.drawer__heading');
  replaceElements('h1.product__title h3');
  replaceElements('h1.header__heading');
  replaceElements('h2.header__heading');
});



// external link will open in new tab

  document.addEventListener('DOMContentLoaded', function () {
    // Get the domain of the current site
    const currentDomain = window.location.hostname;

    // Select all anchor tags
    const links = document.querySelectorAll('a');

    // Iterate over each link
    links.forEach(link => {
      const linkHref = link.getAttribute('href');

      // Check if the link is external
      if (linkHref && linkHref.includes('http') && !linkHref.includes(currentDomain)) {
        link.setAttribute('target', '_blank');
      } else {
        link.setAttribute('target', '_self');
      }
    });
  });





// for spliting words in second line
document.querySelectorAll('.multicolumn-card__heading').forEach(function(heading) {
    var parts = heading.innerHTML.split('(');
    if(parts.length > 1) {
        heading.innerHTML = parts[0] + '<br>(' + parts[1];
    }
});


// document.addEventListener('DOMContentLoaded', function () {
//   function addCtaButton() {
//     // Get the current page URL
//     var currentPage = window.location.pathname;

//     // Check if the user is on the Curapod product page
//     if (currentPage === "/products/curapod") {
//       // Remove the CTA button if it exists
//       var existingCtaButton = document.querySelector('.btn-cta');
//       if (existingCtaButton) {
//         existingCtaButton.parentNode.removeChild(existingCtaButton);
//       }
//       return; // Stop execution to prevent adding the button
//     }

//     // Check if the screen width is 300 pixels or greater
//     if (window.innerWidth >= 300) {
//       // Check if the CTA button already exists
//       if (!document.querySelector('.btn-cta')) {
//         // Create the CTA button element
//         var ctaButton = document.createElement('a');
//         ctaButton.href = '/products/curapod'; // Update this URL to your desired product page
//         ctaButton.className = 'btn btn-cta';
//         ctaButton.textContent = 'Order Now'; // Update this text to your desired CTA text

//         // Find the nav.header__inline-menu element
//         var navMenu = document.querySelector('nav.header__inline-menu');

//         // Insert the CTA button after the navMenu
//         if (navMenu) {
//           navMenu.parentNode.insertBefore(ctaButton, navMenu.nextSibling);
//         }
//       }
//     } else {
//       // Remove the CTA button if it exists and the screen width is below 300 pixels
//       var existingCtaButton = document.querySelector('.btn-cta');
//       if (existingCtaButton) {
//         existingCtaButton.parentNode.removeChild(existingCtaButton);
//       }
//     }
//   }

//   // Initial call to handle page load
//   addCtaButton();

//   // Add event listener for window resize
//   window.addEventListener('resize', addCtaButton);
// });







// document.addEventListener('DOMContentLoaded', function () {
//   function addCtaButton() {
//     const currentPage = window.location.pathname;
//     const headerType = document.body.dataset.headerType; // 'default' or 'header-alt'

//     // Remove existing CTA button if any
//     const existingBtn = document.querySelector('.btn-cta');
//     if (existingBtn) {
//       existingBtn.remove();
//     }

//     // Don't add CTA on this product page
//     if (currentPage === "/products/curapod") return;
//     if (currentPage === "/pages/reviews") return;
//     if (currentPage === "/pages/clinical-trials") return;
//     if (currentPage === "/pages/knee") return;
//     if (currentPage === "/pages/shoulder") return;
//     if (currentPage === "/pages/lower-back") return;
//     if (currentPage === "/pages/neck") return;
//     if (currentPage === "/pages/ankle-and-foot") return;



//     // If using header-alt and screen is less than 768px, don't show button
//     // if (headerType === 'header-alt' && window.innerWidth < 768) return;

//     // Create CTA button
//     const ctaButton = document.createElement('a');
//     ctaButton.className = 'btn btn-cta';

//     if (headerType === 'header-alt') {
//       ctaButton.href = 'https://litemed.co.in/pages/contact-expert';
//       ctaButton.textContent = 'Talk to our expert';
//     } else {
//       ctaButton.href = '/products/curapod';
//       ctaButton.textContent = 'Order Now';
//     }

//     // Insert CTA after nav menu
//     const navMenu = document.querySelector('nav.header__inline-menu');
//     if (navMenu) {
//       navMenu.parentNode.insertBefore(ctaButton, navMenu.nextSibling);
//     }
//   }

//   addCtaButton();
//   window.addEventListener('resize', addCtaButton);
// });


document.addEventListener('DOMContentLoaded', function () {
  function addCtaButton() {
    const currentPage = window.location.pathname;
    const headerType = document.body.dataset.headerType; // 'default' or 'header-alt'
    const isMobile = window.innerWidth < 768;

    // Remove existing CTA button if any
    const existingBtn = document.querySelector('.btn-cta');
    if (existingBtn) {
      existingBtn.remove();
    }

    // Always hide CTA on this product page (all devices)
    // if (currentPage === "/products/curapod") return;
        if (currentPage.startsWith('/products/')) return;


    // Pages where CTA should hide ONLY on mobile
    const mobileHiddenPages = [
      "/pages/reviews",
      "/pages/clinical-trials",
      "/pages/knee",
      "/pages/shoulder",
      "/pages/lower-back",
      "/pages/neck",
      "/pages/ankle-and-foot"
    ];

    if (isMobile && mobileHiddenPages.includes(currentPage)) return;

    // Create CTA button
    const ctaButton = document.createElement('a');
    ctaButton.className = 'btn btn-cta';

    if (headerType === 'header-alt') {
      ctaButton.href = 'https://litemed.co.in/pages/contact-expert';
      ctaButton.textContent = 'Talk to our expert';
    } else {
      ctaButton.href = '/products/curapod';
      ctaButton.textContent = 'Order Now';
    }

    // Insert CTA after nav menu
    const navMenu = document.querySelector('nav.header__inline-menu');
    if (navMenu) {
      navMenu.parentNode.insertBefore(ctaButton, navMenu.nextSibling);
    }
  }

  addCtaButton();
  window.addEventListener('resize', addCtaButton);
});











// document.addEventListener('DOMContentLoaded', function() {
//   function addCtaButton() {
//     // Check if the screen width is 1200 pixels or greater
//     if (window.innerWidth >= 1200) {
//       // Add CTA button after nav.header__inline-menu
//       var navMenu = document.querySelector('div.header__column');
//       if (navMenu) {
//         // Check if the CTA button already exists in the navMenu position
//         if (!document.querySelector('.btn-cta.nav-cta')) {
//           var navCtaButton = document.createElement('a');
//           navCtaButton.href = '/products/curapod'; // Update this URL to your desired product page
//           navCtaButton.className = 'btn btn-cta nav-cta';
//           navCtaButton.textContent = 'Shop Now'; // Update this text to your desired CTA text
//           navMenu.parentNode.insertBefore(navCtaButton, navMenu.nextSibling);
//         }
//       }

//       // Add CTA button below the image
//       var imageContainer = document.querySelector('.image-with-text__media>img');
//       if (imageContainer) {
//         // Check if the CTA button already exists in the imageContainer position
//         if (!document.querySelector('.btn-cta.image-cta')) {
//           var imageCtaButton = document.createElement('a');
//           imageCtaButton.href = '/products/curapod'; // Update this URL to your desired product page
//           imageCtaButton.className = 'btn btn-cta image-cta';
//           imageCtaButton.textContent = 'Shop Now'; // Update this text to your desired CTA text
//           imageContainer.appendChild(imageCtaButton);
//         }
//       }
//     } else {
//       // Remove the CTA button if it exists and the screen width is below 1200 pixels
//       var existingNavCtaButton = document.querySelector('.btn-cta.nav-cta');
//       if (existingNavCtaButton) {
//         existingNavCtaButton.parentNode.removeChild(existingNavCtaButton);
//       }

//       var existingImageCtaButton = document.querySelector('.btn-cta.image-cta');
//       if (existingImageCtaButton) {
//         existingImageCtaButton.parentNode.removeChild(existingImageCtaButton);
//       }
//     }
//   }

//   // Initial call to addCtaButton to handle page load
//   addCtaButton();

//   // Add event listener for window resize
//   window.addEventListener('resize', addCtaButton);
// });




document.addEventListener('scroll', function() {
    var header = document.querySelector('.header-wrapper');
    if (window.scrollY > 0) {
        header.style.top = '40px';
    } else {
        header.style.top = '0';
    }
});

// window.hasNoTopbar =
//     {% if template.name == 'product' and product.tags contains 'no-topbar' %}
//       true
//     {% else %}
//       false
//     {% endif %};

// document.addEventListener('scroll', function () {
//   var header = document.querySelector('.header-wrapper');
//   if (!header) return;

//   /* --------------------------------
//      If product has `no-topbar` tag
//      -------------------------------- */
//   if (window.hasNoTopbar) {
//     header.style.top = '0';
//     return;
//   }

//   /* --------------------------------
//      Normal behavior
//      -------------------------------- */
//   if (window.scrollY > 0) {
//     header.style.top = '40px';
//   } else {
//     header.style.top = '0';
//   }
// });

document.addEventListener("DOMContentLoaded", function () {

  // Run on ALL product pages
  if (!window.location.pathname.startsWith("/products/")) return;

  let style = document.createElement("style");
  style.innerHTML = `
    @media screen and (max-width: 768px) {  

      .product-form__checkout,
      .product-form__buttons {  
        position: fixed;  
        bottom: 0;  
        left: 0;  
        width: 100%;  
        background-color: #fff;
        padding: 10px;  
        z-index: 9;  
        display: flex;  
        flex-direction: column;  
        align-items: center;  
      }  

      .product-form__buttons-row {  
        width: 100%;  
        display: flex;  
        flex-wrap: nowrap !important;
        justify-content: space-between;  
      }  

      .product-form__submit,
      .shopify-payment-button__button {  
        width: 100%;  
        min-width: auto;
        text-align: center;  
      }  

      .product-form__buttons {
        gap: 0px !important;
      }
      
      .product-form__checkout {
        padding: 10px 0px;
      }

      .shopify-payment-button {
        width: 100%;  
      }

      html[data-scheme="dark"] .product-form__checkout,
      html[data-scheme="dark"] .product-form__buttons {
        background-color: #343435;
      }

      .product-form__quantity .quantity,
      .product-form__submit {
        border: 1px solid black;
      }

      html[data-scheme="dark"] .product-form__quantity .quantity,
      html[data-scheme="dark"] .product-form__submit {
        border: 1px solid white;
      }

    }
  `;
  document.head.appendChild(style);
});



// window.hasNoTopbar =
//     {% if template.name == 'product' and product.tags contains 'no-topbar' %}
//       true
//     {% else %}
//       false
//     {% endif %};

// document.addEventListener('scroll', function () {
//   var header = document.querySelector('.header-wrapper');
//   if (!header) return;

//   /* --------------------------------
//      If product has `no-topbar` tag
//      -------------------------------- */
//   if (window.hasNoTopbar) {
//     header.style.top = '0';
//     return;
//   }

//   /* --------------------------------
//      Normal behavior
//      -------------------------------- */
//   if (window.scrollY > 0) {
//     header.style.top = '40px';
//   } else {
//     header.style.top = '0';
//   }
// });